import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { debounce } from "lodash";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import EditableLabel from "../../components/EditableLabel";
import { Toolbar, ToolbarGroup } from "../../components/Toolbar";
import styles from "../../components/Toolbar.module.css";
import { emailsList, openModal, updateCampaign } from "../../actions";

export class ViewCampaignToolbar extends Component {
  constructor(props) {
    super(props);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.openCreateFolderModal = this.openCreateFolderModal.bind(this);
    this.onUpdateName = this.onUpdateName.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.search = debounce(this.search.bind(this), 300);
    this.renderParentNav = this.renderParentNav.bind(this);
  }

  onUpdateName(name) {
    const { accountId, campaign } = this.props;
    this.props.updateCampaign(accountId, campaign.id, {
      name,
    });
  }

  onSearch(e) {
    const searchTerm = e.currentTarget.value;
    this.search(searchTerm);
  }

  search(searchTerm) {
    this.props.emailsList(
      this.props.accountId,
      {
        name: searchTerm,
      },
      true
    );
  }

  openCreateModal() {
    const { accountId, campaign } = this.props;

    this.props.openModal("create-email", {
      accountId,
      campaignId: campaign.id,
    });
  }

  openCreateFolderModal() {
    const { accountId, campaign } = this.props;

    this.props.openModal("create-campaign", {
      accountId,
      parentCampaign: campaign.id,
    });
  }

  renderParentNav(campaign) {
    const { accountId } = this.props;
    return campaign && campaign.Parent
      ? [
          this.renderParentNav(campaign.Parent),
          <Link
            key={campaign.Parent.id}
            to={`/clients/${accountId}/campaigns/${campaign.Parent.id}`}
          >
            <Button type="link">
              <Icon icon="folder-open" />
              <span className={styles.spacer} />
              {campaign.Parent.name}
            </Button>
          </Link>,
          <Icon
            key={`${campaign.Parent.id}-icon`}
            icon="caret-right"
            className={styles.spacer}
          />,
        ]
      : undefined;
  }

  render() {
    const { accountId, campaign } = this.props;

    return (
      <div>
        <Toolbar>
          <ToolbarGroup>
            <Link to={`/clients/${accountId}/campaigns`}>
              <Button type="link" className={styles.crumb}>
                <Icon icon="folder-open" />
                <span>Campaigns</span>
              </Button>
            </Link>
            <Icon icon="caret-right" style={{ marginRight: 10 }} />
            {this.renderParentNav(campaign)}
            <EditableLabel
              icon="folder-open"
              value={campaign && campaign.name}
              onChange={this.onUpdateName}
              width="400px"
            />
          </ToolbarGroup>

          <ToolbarGroup width="360px" align="right">
            <Button type="link" onClick={this.openCreateFolderModal}>
              Create Folder
            </Button>
            <Button onClick={this.openCreateModal}>Create Email</Button>
          </ToolbarGroup>
        </Toolbar>
      </div>
    );
  }
}

ViewCampaignToolbar.propTypes = {
  openModal: PropTypes.func.isRequired,
};

// Connect actions
export default connect(null, {
  emailsList,
  openModal,
  updateCampaign,
})(ViewCampaignToolbar);
